angular
    .module("skillBuilderSaaS")
    .directive("sbSaving", function () {
    return {
        restrict: "E",
        template: "<div class='sb-saving-div'><i class='fa fa-circle-o-notch fa-spin'></i> <span translate='common.sb-saving'></span></div>"
    };
});
